module.exports = __webpack_public_path__ + "static/media/029.53ed78e5.png";